import * as React from 'react';
import gettext from '@sdk/lang/gettext';

import timeclockImage from '../../assets/images/premium-features/mobile-tc.png';
import kioskImage from '../../assets/images/premium-features/kiosk.png';
import clockInImage from '../../assets/images/premium-features/x-clockin-out.png';
import geofencingImage from '../../assets/images/premium-locked-screen/timeclock/geofencing.png';
import timesheetsImage from '../../assets/images/premium-locked-screen/timeclock/timesheets.png';

import { PremiumFeaturePreviewRow } from './PremiumFeaturePreviewRow';

export const TimeclockFeaturePreview: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <PremiumFeaturePreviewRow
        image={timeclockImage}
        imageWidth={160}
        title={gettext('Turn any phone into time clock')}
        description={gettext(
          'Allow employees to clock in and out of their shifts right from their phones. Get notified when they are running late or forget to clock in.'
        )}
      />
      <PremiumFeaturePreviewRow
        image={kioskImage}
        imageWidth={280}
        title={gettext('Set up time clock terminal')}
        description={gettext(
          'Track employee time from a designated terminal. Use the on-site time clock alone, or in combination with mobile and web time clock.'
        )}
        reverse
      />
      <PremiumFeaturePreviewRow
        image={geofencingImage}
        imageWidth={240}
        title={gettext('Enable location-specific time clock')}
        description={gettext(
          'Ensure employees are in the right place when they are clocking in and out with dependable geofencing tools.'
        )}
      />
      <PremiumFeaturePreviewRow
        image={clockInImage}
        imageWidth={170}
        title={gettext('Prevent early clock-ins and forgotten clock-outs')}
        description={gettext(
          'Set limits to how early employees are able to clock in and automatically clock employees out, if they forget to do it themselves, to save labor costs and prevent time theft.'
        )}
        reverse
      />
      <PremiumFeaturePreviewRow
        image={timesheetsImage}
        imageWidth={265}
        title={gettext('Export timesheets for payroll processing')}
        description={gettext(
          'Review the timesheets at the end of each pay period and export payroll reports for seamless payroll processing.'
        )}
      />
    </>
  );
};
